import BaseUtil from "../../../util/BaseUtil";
import UserTypeUtil from "../../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const chartTypeMap = {
    pie: "环状图",
    bar: "柱状图",
};

const initState = {
    selectedUnitIds: null,
    selectedUserTypes: UserTypeUtil.getAllUserTypeCodes(),
    chartType: "pie", // 图表类型
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    chartsLoading: false, // 图表数据加载
    chartsData: null, // 图表数据

    inServiceDetailVisible: false, // 查看详情
    clickedChart: null, // 点击查看详情的图标

    // 筛选
    // filterOriginObj: null, // 过滤值原始对象，转变为filterData, filterDisplay前的值
    filterData: null,
    filterDisplay: null,
    // 筛选初始化所需数据，由父组件请求后传递给子组件 - 多个筛选按钮
    filterInitData: {
        groups: [],
        items: [],
        dicts: {},
    },

    itemFiltered: null,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    chartTypeMap,
};
export default viewModel;
